@if(blueprint(); as blueprint) {

  <div class="d-flex gap-2 justify-content-between">
    <b class="d-block mb-2">{{ 'complexArticleBlueprint.label.rules' | translate }}</b>
    <span class="dropdown" dropdown #dropdown="bs-dropdown">
      <button class="btn btn-primary btn-sm" data-toggle="dropdown" dropdownToggle data-testid="add-rule">
            <app-svg-icon type="plus" size="medium-small"/>
            <span>{{ 'global.label.add' | translate }}</span>
      </button>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" data-testid="add-rule-dropdown">
            @for (ruleDefinition of allRules; track $index) {
              <li>
                <a class="dropdown-item d-flex gap-2" [attr.data-testid]="ruleDefinition.name" (click)="addRule(ruleDefinition.name)">
                 <span>{{ ('complexArticleBlueprint.rule.title.' + ruleDefinition.name) | translate }}</span>
                </a>
              </li>
            }
       </ul>
    </span>
  </div>

  <div class="rules py-3">
  @for (ruleUsage of blueprint.rules; track $index; let ruleIndex = $index ) {
    @let rule = ruleUsage.name | complexArticleRuleFromUsage;

    <div class="card">
      <div class="card-header d-flex gap-1">
        <span>{{ $index + 1 }}.</span>
        <select [ngModel]="ruleUsage.name" (change)="updateRule(ruleIndex , $event); update.emit()">
          @for (ruleDefinition of allRules; track $index) {
            <option [value]="ruleDefinition.name">
              {{ ('complexArticleBlueprint.rule.title.' + ruleDefinition.name) | translate }}
            </option>
          }
        </select>
        <div class="flex-grow-1"></div>
        <button class="btn btn-secondary btn-icon" (click)="moveRule(ruleIndex, -1)">
          <app-svg-icon type="arrow-up"/>
        </button>
        <button class="btn btn-secondary btn-icon" (click)="moveRule(ruleIndex, 1)">
          <app-svg-icon type="arrow-down"/>
        </button>
        <button class="btn btn-secondary btn-icon" (click)="deleteRule(ruleIndex)">
          <app-svg-icon type="close"/>
        </button>
      </div>

      <form class="p-3">

        @if (!rule) {
          <p>{{ 'complexArticleBlueprint.label.unknown_rule' | translate : {'0': ruleUsage.name} }}</p>
        } @else {

          @for (paramUsageName of Object.keys(rule.paramsSchema); track $index) {
            @let fieldName = ruleUsage.name + '-' + paramUsageName;
            @let paramSchema = rule.paramsSchema[paramUsageName];

            <div class="mb-2 d-flex justify-content-between">
              <label [for]="fieldName">{{ paramUsageName }}</label>

              @let propertyValue = ruleUsage.params | propertyValue : paramUsageName : paramSchema.type.toLowerCase() : paramSchema.isArray;

              @if (paramSchema.isArray) {
                <input
                  [placeholder]="'semicolon separated list'"
                  [name]="fieldName"
                  [id]="fieldName"
                  [value]="propertyValue"
                  (change)="updateArrayParam(ruleIndex, paramUsageName, paramSchema.type, $event); update.emit()"
                  type="text"
                >
              } @else {
                @switch (paramSchema.type) {
                  @case ('STRING') {
                    <input [name]="fieldName" [id]="fieldName"
                      [value]="propertyValue"
                      (change)="setParamValue(ruleIndex, paramUsageName, paramSchema.type, $event); update.emit()"
                      type="text">
                  }
                  @case ('INT') {
                    <input [name]="fieldName" [id]="fieldName"
                      [value]="propertyValue"
                      (change)="setParamValue(ruleIndex, paramUsageName, paramSchema.type, $event); update.emit()"
                      type="number" [max]="paramSchema.max" [min]="paramSchema.min">
                  }
                  @case ('FLOAT') {
                    <input [name]="fieldName" [id]="fieldName"
                      [value]="propertyValue"
                      (change)="setParamValue(ruleIndex, paramUsageName, paramSchema.type, $event); update.emit()"
                      type="number" step="0.01" [max]="paramSchema.max" [min]="paramSchema.min">
                  }
                  @case ('BOOLEAN') {
                    <input [name]="fieldName" [id]="fieldName"
                      [checked]="propertyValue"
                      (change)="setParamValue(ruleIndex, paramUsageName, paramSchema.type, $event); update.emit()"
                      type="checkbox">
                  }
                }
              }
            </div>
          }
        }
      </form>
      <a class="link small pb-2 ps-2" [href]="'complexArticleBlueprint.rule.link.' + ruleUsage.name | translate" target="_blank">
        <app-svg-icon type="question_circle" inline="true" class="me-1"/>
        {{ 'global.label.help' | translate }}
      </a>
    </div>
  }
</div>
}
